import useResponsive from 'hooks/useResponsive';

import Timer from './Timer';

export default function Promo({ plansSetting, language }) {
  const { isMobile, isTablet } = useResponsive();
  const isSmallDevice = isMobile || isTablet;
  const bannerPromo = plansSetting?.bannerDesktop || [];
  const bannerPromoMobile = plansSetting?.bannerMobile || [];
  const showTimer = plansSetting?.showTimer;

  return (
    <div className={'relative'}>
      {showTimer && <Timer plansSetting={plansSetting} />}
      <img
        alt="promo"
        src={`
          ${
            !isSmallDevice
              ? `${bannerPromo[language]}`
              : `${bannerPromoMobile[language]}`
          }
          `}
      />
    </div>
  );
}
